import { render } from "./fanatic_codes.vue?vue&type=template&id=2df7762c"
import script from "./fanatic_codes.vue?vue&type=script&lang=js"
export * from "./fanatic_codes.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__